import React from 'react';
import './styles.scss';

const EntryComponent = props => {
  const { mention, searchValue, isFocused, ...parentProps } = props;

  return (
    <div {...parentProps} className="ickyc-mention-entry">
      <div className="ickyc-mention-entry__name">{mention.name}</div>
    </div>
  );
};

export default EntryComponent;
